var navbar = document.getElementById('navbar');
var header = document.getElementById('header');
var content = document.getElementById('content');
export var links = {
    navbar: navbarLinks,
    content: contentLinks,
};
function navbarLinks() {
    return Array.from(navbar.getElementsByClassName('nav-link')).concat(Array.from(header.getElementsByClassName('nav-link')));
}
function contentLinks() {
    return Array.from(content.getElementsByClassName('nav-link'));
}
export var cartButtons = {
    details: [],
    addToCart: [],
    substractFromCart: [],
    deleteFromCart: []
};
export function getCartBtns() {
    var details = Array.from(content.getElementsByClassName('js-product-detail'));
    var addToCart = Array.from(content.getElementsByClassName('js-add'));
    var substractFromCart = Array.from(content.getElementsByClassName('js-substract'));
    var deleteFromCart = Array.from(content.getElementsByClassName('js-delete'));
    details.length > 0 ? cartButtons.details = details : cartButtons.details = [];
    addToCart.length > 0 ? cartButtons.addToCart = addToCart : cartButtons.addToCart = [];
    substractFromCart.length > 0 ? cartButtons.substractFromCart = substractFromCart : cartButtons.substractFromCart = [];
    deleteFromCart.length > 0 ? cartButtons.deleteFromCart = deleteFromCart : cartButtons.deleteFromCart = [];
}
export var sortingOptions = {
    sortType: null,
    sortKey: null
};
export function getSortingOptions() {
    sortingOptions.sortType = document.getElementById('sorting-type');
    sortingOptions.sortKey = document.getElementById('key');
}
